export const BILLING_CYCLES = [
  { discountPercent: 0, label: "Monthly", months: 1, value: "monthly" },
  { discountPercent: 5, label: "Quarterly", months: 3, value: "quarterly" },
  { discountPercent: 10, label: "Annually", months: 12, value: "annually" },
];

export function billingCycleDetails(cycle) {
  return BILLING_CYCLES.find((option) => option.value === cycle) || BILLING_CYCLES[0];
}

export function billingCyclePrice(priceMinor, cycle) {
  const { discountPercent, months } = billingCycleDetails(cycle);
  return Math.round((Number(priceMinor || 0) * months * (100 - discountPercent)) / 100);
}

export function billingCycleInterval(cycle) {
  const { months } = billingCycleDetails(cycle);
  return months === 1 ? "per month" : `every ${months} months`;
}
